module.exports = __webpack_public_path__ + "img/tron (48).39dee831.jpg";